module.exports = __webpack_public_path__ + "static/img/NPower-Default.1f575e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fileTypes/NPower-Default.png
// module id = 1784
// module chunks = 0